const isValidBankAccount = value => /^\d+$/.test(value) || /^([A-Z]{2})(\d{1,})([A-Z\d]+)$/.test(value.toLocaleUpperCase());

export default isValidBankAccount;
